export default "__VITE_ASSET__0824b4c3__"